import axios from "../../../../config/axiosWithLocation";
import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../../../context/authContext";
import { updateOrder } from "../../../../redux/order";
import classes from "./Order.module.scss";

const Order = ({ id, num, type, status, createdAt }) => {
  const dispatch = useDispatch();
  const { selectedLocation } = useSelector((state) => state.location);
  const { loggedInUser } = useContext(AuthContext);
  let orderStatusText = null;
  let orderStatusStyleClasses = classes.OrderStatus;
  let acceptButtonStyleClasses = [classes.ResponseButton, classes.Accept].join(
    " "
  );
  let rejectButtonStyleClasses = [classes.ResponseButton, classes.Reject].join(
    " "
  );

  switch (status) {
    case "cancel":
      orderStatusText = "Void";
      orderStatusStyleClasses = [
        orderStatusStyleClasses,
        classes.OrderVoid,
      ].join(" ");
      break;
    case "complete":
      orderStatusText = "Completed";
      orderStatusStyleClasses = [
        orderStatusStyleClasses,
        classes.OrderCompleted,
      ].join(" ");
      break;
    case "draft":
      orderStatusText = "On Hold";
      orderStatusStyleClasses = [
        orderStatusStyleClasses,
        classes.OrderOnHold,
      ].join(" ");
      break;
    case "deliver":
      orderStatusText = "Delivery";
      orderStatusStyleClasses = [
        orderStatusStyleClasses,
        classes.OrderDelivery,
      ].join(" ");
      break;
    case "processing":
      orderStatusText = "Serving";
      orderStatusStyleClasses = [
        orderStatusStyleClasses,
        classes.OrderServing,
      ].join(" ");
      break;

    default:
      break;
  }

  const onAccept = () => {
    axios
      .post(
        "/order/status",
        {
          restaurant_id: loggedInUser.restaurant_id,
          order_id: id,
          status: "complete",
          order_no: num,
          location_id: selectedLocation,
        }
      )
      .then((res) => {
        dispatch(updateOrder({ id, status: "complete" }));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const onReject = () => {
    axios
      .post(
        "/order/status",
        {
          restaurant_id: loggedInUser.restaurant_id,
          order_id: id,
          status: "complete",
          order_no: num,
          location_id: selectedLocation,
        }
      )
      .then((res) => {
        dispatch(updateOrder({ id, status: "complete" }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div key={createdAt} className={classes.OrderCard}>
      <div className={classes.ResponseButtons}>
        {status !== "complete" && status !== "cancel" && (
          <button onClick={onAccept} className={acceptButtonStyleClasses}>
            Accept
          </button>
        )}
        {status !== "complete" && status !== "cancel" && (
          <button onClick={onReject} className={rejectButtonStyleClasses}>
            Reject
          </button>
        )}
        {/* {status === "complete" && (
          <p className={classes.OrderCompleteBox}>Order Completed</p>
        )}
        {status === "cancel" && (
          <p className={classes.OrderCancelledBox}>Order Cancelled</p>
        )} */}
      </div>
      <div className={orderStatusStyleClasses}>
        <div className={classes.Circle}></div> {orderStatusText}
      </div>
      <p>Order ID</p>
      <p>#{id}</p>
      <p>Date</p>
      <p>{new Date(createdAt).toDateString()}</p>
      <p>Type of Order</p>
      <p>
        <strong>{type}</strong>
      </p>
    </div>
  );
};

export default Order;
